export const labs: { [key: string]: string } = {
  foundation_one: 'Foundation',
  tempus: 'Tempus',
}
